import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'


const SingleOrderButtons = ({ order, user }) => {



    return (
        <Fragment>

            <div className="flex items-center gap-[0.5vmax] justify-center">
                <Link to={`/orders/order-details?order_id=${order?.id}`} className="px-[1vmax] py-[0.4vmax] flex-center bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 border border-blue-200 transition-colors text-[1.2vmax] lg:text-[0.8vmax] font-semibold whitespace-nowrap">
                    View
                </Link>
            </div>


        </Fragment>
    )
}

export default SingleOrderButtons